import React from 'react'
import { PolicyText, Wrapper } from '@/components/ProductDisclaimer.styles'
import Icon from '@/components/Icons'

const ProductDisclaimer: React.FC<{ cancellationPolicy: string }> = ({ cancellationPolicy }) => {
  return (
    <>
      {cancellationPolicy.toLowerCase() === 'no cancellation' ? (
        <Wrapper negative>
          <Icon name="exclamationCircle" />
          <PolicyText>No cancellation allowed for this experience</PolicyText>
        </Wrapper>
      ) : (
        <Wrapper>
          <Icon name="confirmationGreen" />
          <PolicyText>{cancellationPolicy}</PolicyText>
        </Wrapper>
      )}
    </>
  )
}

export default ProductDisclaimer
